import { T } from "../../../styles/Theme";

export const TelefoniaIcon = () => {
  return (
    <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.568 0A2.573 2.573 0 0 0 0 2.568C0 18.825 13.175 32 29.432 32A2.573 2.573 0 0 0 32 29.432v-5.876a2.573 2.573 0 0 0-2.568-2.568c-2.003 0-3.924-.32-5.715-.912l-.012-.004-.012-.004a2.756 2.756 0 0 0-.776-.121c-.668 0-1.302.258-1.796.724l-6.07 5.523a27.785 27.785 0 0 1-9.705-10.027 499.293 499.293 0 0 0 3.665-3.253l1.59-1.424.654-.588.005-.005.006-.005c.747-.694.939-1.717.662-2.597l-.002-.006-.002-.006a18.186 18.186 0 0 1-.912-5.715A2.573 2.573 0 0 0 8.444 0H2.568Zm26.864 30.222c-4.6 0-8.936-1.122-12.751-3.108l5.65-5.14.007-.007a.832.832 0 0 1 .58-.243c.057 0 .15.013.255.044a19.96 19.96 0 0 0 6.26.997c.432 0 .79.358.79.79v5.877c0 .433-.358.79-.79.79ZM7.826 11.59c-1.084.97-2.355 2.103-3.327 2.957A27.55 27.55 0 0 1 1.778 2.568c0-.433.357-.79.79-.79h5.876c.433 0 .79.357.79.79 0 2.191.35 4.298 1 6.266.09.291.015.574-.174.752l-.647.58c-.404.364-.964.866-1.587 1.423Z"
        fill={T.blue}
      />
    </svg>
  );
};
